import $ from 'jquery';

require( 'select2' );

const $countrySelectField = $( '.address__select-2 .address_country > select' );
const $countryLabel = $( '.address__select-2 .address_country > label' );

$countrySelectField.select2({
	allowClear: true,
	placeholder: $countryLabel.text(),
});